export const OMIT_ATTRS = [
  'loading',
  'enable',
  'okText',
  'cancelText',
  'placement',
  'dynamicDisabled',
  'getPopupContainer',
];
